"use strict";

function showModalView() {
  let startY;
  let endY;
  let threshold = 50;

  function disableScroll() {
    window.addEventListener('scroll', preventScroll, { passive: false });
    document.addEventListener('touchmove', preventScroll, { passive: false });
  }

  function enableScroll() {
    window.removeEventListener('scroll', preventScroll, { passive: false });
    document.removeEventListener('touchmove', preventScroll, { passive: false });
  }

  function preventScroll(e) {
    e.preventDefault();
  }

  $("body").on("click", ".view-size-color", function (e) {
    var $htmlInfoSizeColor = $(this).parents(".product-tile").find(".tileVariationContent").html();
    $("#modal-view .modal-body-view").empty().html($htmlInfoSizeColor);

    var $modalContent = $("#modal-view .modal-body-view");
    var $colorDiv = $modalContent.find(".color-size-plp").first();
    var $sizeDiv = $modalContent.find(".color-size-plp").last();

    if ($colorDiv.index() < $sizeDiv.index()) {
      $colorDiv.insertAfter($sizeDiv);
    }

    $("#modal-view").addClass("modal-view-show").removeClass("modal-view-close");
    $(".modal-content-view").animate({ bottom: "0%" }, 200);
    $("body").addClass("menu-open");
    disableScroll();
  });

  $(".close-view").click(function () {
    closeModal();
  });

  $(window).click(function (event) {
    if ($(event.target).is("#modal-view")) {
      closeModal();
    }
  });

  function closeModal() {
    $(".modal-content-view").animate({ bottom: "-100%" }, 200, function () {
      setTimeout(function () {
        $("#modal-view").addClass("modal-view-close").removeClass("modal-view-show");
      }, 220);
      $("body").removeClass("menu-open");
      enableScroll();
    });
  }

  $(".modal-content-view").on("touchstart", function (event) {
    startY = event.touches[0].clientY;
  });

  $(".modal-content-view").on("touchmove", function (event) {
    endY = event.touches[0].clientY;
  });

  $(".modal-content-view").on("touchend", function (event) {
    if (startY && endY && endY - startY > threshold) {
      closeModal();
    }
    startY = null;
    endY = null;
  });
}


showModalView();

function updateColorSwatches() {
  var viewportWidth = $(window).width();
  var $maxColors = 9;

  if (viewportWidth >= 360 && viewportWidth < 390) {
      $maxColors = 10;
  } else if (viewportWidth > 389 && viewportWidth <= 420) {
      $maxColors = 11;
  } else if (viewportWidth >= 421) {
      $maxColors = 12;
  }

  $('.modal-plp-size-color').each(function() {
    
      var $container = $(this);
      $container.find('.color-plp-Mobile').eq($maxColors - 1).nextAll('.color-plp-Mobile:not(.rest)').hide().addClass('color-hidden');

      var $hiddenElementsCount = $container.find('.color-plp-Mobile.color-hidden').length;
      var $hiddenElementsCount = $container.find('.color-plp-Mobile.color-hidden').length;
      
        var $restSpan = $container.find('.rest');
        if ($hiddenElementsCount !== 0) {
            $restSpan.text('+' + $hiddenElementsCount);
        } else {
            $restSpan.hide();
        }
  });
}

updateColorSwatches();

$(window).resize(function() {
  updateColorSwatches();
});

module.exports = {
  sizeColorPlp: function () {

    function updateContainerElements($container) {
      var $sizeElements = $container.find(".size-plp span:not(.more-sizes)");
      var $containerWidth = $container.width() - $container.find(".size-plp span.more-sizes").width();
      var $totalWidth = 0;
      var $visibleWidth = 0;
    
      var $visibleElements = $();
    
      $sizeElements.each(function () {
        var $element = $(this);
        var $elementWidth = $element.outerWidth(true);
    
        if ($visibleWidth + $elementWidth <= $containerWidth) {
          $visibleWidth += $elementWidth;
          $visibleElements = $visibleElements.add($element);
        }
    
        $totalWidth += $elementWidth;
      });
    
      if ($totalWidth <= $containerWidth) {
        $container.addClass("min-sizes").removeClass("max-sizes");
        $container.parents(".tileVariation-Desktop").find(".more-sizes").addClass("d-none");
      } else {
        $container.addClass("max-sizes").removeClass("min-sizes");
        $container.parents(".tileVariation-Desktop").find(".more-sizes").removeClass("d-none");
    
        $sizeElements.hide();
    
        $visibleElements.show();
      }
    }
    
    var $containers = $('.tileVariation-Desktop .color-size-plp[data-attr="size"]');
    
    $containers.each(function () {
      updateContainerElements($(this));
    });
    
    $(window).resize(function () {
      $containers.each(function () {
        updateContainerElements($(this));
      });
    });
    
    $(".search-results .product-tile").each(function () {
      var tuileVariation = $(this).find(".tileVariation-Desktop");
      var windowWidth = $(window).width();
      
      if (windowWidth > 840) {
    
        $(this).mouseenter(function () {
          tuileVariation.css({'height': '100%' , 'padding' : '2px 8px 2px 4px'}); 
        }).mouseleave(function () {
          tuileVariation.css({'height': '0px' , 'padding' : '0px 8px 0px 4px'}); 
        });
      }
    });

    var $colorSwatch = $(".swatch-circle");
    $colorSwatch.each(function () {
      var $self = $(this),
        $colorValue = $self.data("attr-value");

      if ($colorValue) {
        var $strColor = $colorValue.substring(0, 3);
        if ($strColor === "WHI") {
          $self.addClass("swatch-white");
        }
      }
    });
  }
}